const e = "_expandable_62kig_7", n = "_tag_62kig_33", t = "_button_62kig_39", _ = "_chevron_62kig_69", o = "_content_62kig_78", c = "_closed_62kig_85", l = "_blue_62kig_97", s = "_white_62kig_100", i = "_open_62kig_106", g = "_line_62kig_110", a = "_yellow_62kig_120", k = {
  expandable: e,
  tag: n,
  button: t,
  chevron: _,
  content: o,
  closed: c,
  blue: l,
  white: s,
  open: i,
  line: g,
  yellow: a
};
export {
  l as blue,
  t as button,
  _ as chevron,
  c as closed,
  o as content,
  k as default,
  e as expandable,
  g as line,
  i as open,
  n as tag,
  s as white,
  a as yellow
};
//# sourceMappingURL=expandable.module.less.js.map
